/** Marketing/landing site URL — where sign-in lives (a Google popup).
 *  Unauthenticated visitors to the app are bounced here; the app has no
 *  login page of its own. Resolved at runtime from `window.__APP_CONFIG__`
 *  (injected by /config.js — see app/runtime_config.py); falls back to the
 *  apex domain (strip the leftmost subdomain: tickview.pulsarix.net →
 *  pulsarix.net), which is correct for prod but not dev (hence dev sets it). */
export function landingUrl(): string {
  const cfg = window.__APP_CONFIG__?.landingUrl;
  if (cfg) return cfg;
  const { protocol, hostname, port } = window.location;
  const parts = hostname.split(".");
  if (parts.length > 2) return `${protocol}//${parts.slice(1).join(".")}`;
  return `${protocol}//${hostname}${port ? ":" + port : ""}`;
}

let _redirecting = false;

/** Send the whole window back to the sign-in (landing) site. Used on auth
 *  failure (no / expired session) instead of surfacing an error. Guarded
 *  so a burst of simultaneous 401s only triggers one navigation. */
export function redirectToSignIn(): void {
  if (_redirecting) return;
  _redirecting = true;
  window.location.replace(landingUrl());
}
